import { SESSION_HINT_COOKIE } from "./session-hint-header";

const SESSION_MARK_ATTRIBUTE = "data-session";

export const SESSION_MARK_SCRIPT = `document.cookie.split(";").some(function(c){return c.trim()==="${SESSION_HINT_COOKIE}=1"})&&document.documentElement.setAttribute("${SESSION_MARK_ATTRIBUTE}","")`;

export function syncSessionMark(hasSession: boolean): void {
  document.documentElement.toggleAttribute(SESSION_MARK_ATTRIBUTE, hasSession);
}
